import { useStaticQuery, graphql } from "gatsby"
import { useLanguage } from "src/components/utils"
import { flatMap } from "lodash"
import { transformForUI } from "../transformers"

// Notice 카테고리 정의
const NOTICE_CATEGORY = ["ALL", "NOTICE"]

export default function useContent() {
    const language = useLanguage()

    // 사전에 빌드된 페이지의 데이터를 사용합니다
    const { allSitePage } = useStaticQuery(graphql`
        query {
            allSitePage(filter: {path: {regex: "/\\/notice\\/[^\\/]+\\/$/"} }) {
                edges {
                    node {
                        path
                        context {
                            title
                            slug
                            excerpt
                            content
                            date
                            categories {
                                name
                            }
                            tags {
                                name
                                wordpress_id
                            }
                            featured_media {
                                source_url
                            }
                        }
                    }
                }
            }
        }
    `)

    // 사이트 페이지 데이터를 필터링
    const categories = NOTICE_CATEGORY

    // 포스트 데이터 준비
    const postRawData = allSitePage.edges
        .filter(({ node }) => node.path.startsWith(`/${language}/notice/`))
        .map(({ node }) => {
            const post = node.context || {}
            const tags = flatMap(post.tags || [], tag => tag.name)
            
            // 태그에 'notice' 태그가 있는지 확인
            const hasNoticeTag = tags && tags.some(tag => 
                tag && tag.toLowerCase() === 'notice'
            )
            
            // NOTICE 태그가 있으면 NOTICE 카테고리로 표시
            const displayCategory = hasNoticeTag ? "NOTICE" : ""
            
            return {
                ...post,
                tags,
                category: displayCategory,
                imgSrc: post.featured_media ? post.featured_media.source_url : null,
                excerpt: post.excerpt ? post.excerpt.replace(/<[^>]*>/g, '') : "",
                to: node.path
            }
        });
    
    // 변환 함수를 통해 UI에 맞게 데이터 처리
    const posts = transformForUI(postRawData, language, 'notice');

    return { categories, posts, loading: false }
}